export default "__VITE_ASSET__DGv7SiJX__"